import classNames from 'classnames';
import i18next from 'i18next';
import { FC } from 'react';
import { Field } from 'react-final-form';

import { validatorRequired } from '~src/services/validators';
import { SvgIconName } from '~src/shared/SvgIcon';

import { ItemTypeCard, ItemTypeDescription, ItemTypeIcon, ItemTypeName } from './cardsRadio.sc';

interface Props {
  t: i18next.TFunction;
  itemTypeSelected: string;
  item: {
    value: string;
    name: string;
    iconName: SvgIconName;
    description: string;
  };
  index: number;
  fieldName: string;
}

const CardsRadio: FC<Props> = ({ t, itemTypeSelected, item, index, fieldName }) => {
  const viewBoxWidth: number =
    item.iconName === 'iconSquare10' || item.iconName === 'iconSquareDots' ? 60 : 25;

  return (
    <ItemTypeCard className={classNames({ selected: itemTypeSelected === item.value })}>
      <ItemTypeIcon name={item.iconName} viewBoxWidth={viewBoxWidth} />
      <ItemTypeName data-translation={item.name}>{t(item.name)}</ItemTypeName>
      <ItemTypeDescription data-translation={item.description}>{t(item.description)}</ItemTypeDescription>
      <Field
        name={fieldName}
        component="input"
        type="radio"
        id={`${fieldName}_${index}`}
        value={item.value}
        validate={validatorRequired}
      />
    </ItemTypeCard>
  );
};

export default CardsRadio;
